import { MediaItem } from "@/lib/content-service/types/ContentServiceProduct"
import { ImageSize } from "@/types/centra/checkout-api/products/post-products"

export const OLDgetImageSrc = (
    width: number,
    sources: {
        mini?: ImageSize[] | string[]
        small: ImageSize[] | string[]
        standard: ImageSize[] | string[]
        big: ImageSize[] | string[]
        full?: ImageSize[] | string[]
    }
): string => {
    if (width <= 1440) {
        if (typeof sources.small?.[0] === "object") {
            return sources.small?.[0]?.url
        } else {
            return sources.small?.[0]
        }
    } else {
        if (typeof sources.standard?.[0] === "object") {
            return sources.standard?.[0]?.url
        } else {
            return sources.standard?.[0]
        }
    }
}

type MediaSources = {
    mini?: (MediaItem | string)[]
    small: (MediaItem | string)[]
    standard: (MediaItem | string)[]
    big: (MediaItem | string)[]
    full?: (MediaItem | string)[]
}

export const getImageSrc = (width: number, sources: MediaSources): string => {
    let selectedArray: (MediaItem | string)[] = []

    if (width <= 1440) {
        selectedArray = sources.small
    } else {
        selectedArray = sources.standard
    }

    if (!selectedArray || selectedArray.length === 0) {
        return "" // Or return a fallback URL if desired.
    }

    const firstItem = selectedArray[0]

    if (typeof firstItem === "object" && firstItem !== null && "url" in firstItem) {
        return (firstItem as MediaItem).url
    }
    return firstItem as string
}
